import { Component, ViewChild, ViewEncapsulation, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CriteriaFormComponent } from '../criteria/criteria.form.component';
import { VisionService } from '../services/vision.service';
import { JobService } from '../services/job.service';
import { SpinnerService } from '../services/spinner';
import { SurveyTypes } from '../models/surveytypes';
import { CriteriaService } from '../services/criteria.service';
import { CriteriaOptionDetails } from '../models/dto/criteria-options-details';
import { Observable } from 'rxjs/Observable';
import { SurveyDetails } from '../models/dto/survey';
import { CriteriaDetails } from '../models/dto/criteria';
import { VisionModel } from '../models/vision.model';
import { CriteriaModel } from '../models/criteria.model';

@Component({
    selector: 'app-criteria.edit',
    templateUrl: './criteria.edit.component.html',
    styleUrls: ['./criteria.edit.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CriteriaEditComponent implements OnInit, OnDestroy {

    closeResult: string;
    user: any;
    email: string;
    user_data: any;
    user_id: string;
    surveyData: any;
    surveyTypeId: number;
    criteriaId: string;
    newSurveyTitle: string;
    isCreateNewSurvey = false;
    isEditMode = true;
    title = '';
    form1Title = '';
    currentCriteria: CriteriaDetails;
    userSurveys: Array<SurveyDetails>;
    importance: number;
    isConditions: boolean;
    errorMsg = '';
    criteriaData: CriteriaDetails;
    conditionItems: Array<CriteriaOptionDetails> = [];
    showSpinner = false;
    disableButton = false;
    dataInserted = false;
    current_survey: any;
    survey_data: SurveyDetails;
    current_criterias: Array<CriteriaDetails>;
    criterias_titles = '';
    tempForms: Array<any> = [];
    displayArray: Array<any> = [];
    editValuesArray: Array<any> = [];
    allAnswers: Array<any> = [];
    allValid = 0;

    // forms
    criteriaTitle: FormControl;
    criteriaCondition: FormControl;
    criteriaForm: FormGroup;

    constructor(private visionService: VisionService, private criteriaService: CriteriaService,
        private renderer: Renderer2,
        private surveyTypes: SurveyTypes, private modalService: NgbModal, private route: ActivatedRoute, private jobService: JobService,
        private router: Router, private visionModel: VisionModel, private criteriaModel: CriteriaModel, private spinnerService: SpinnerService) {

        this.renderer.addClass(document.body, 'container_bg');
        this.user = JSON.parse(localStorage.getItem('user_data'));
        this.email = this.user.email;
        this.user_id = this.user.id;
        this.newSurveyTitle = localStorage.getItem('vision_title');
        this.surveyTypeId = this.surveyTypes.getTitleId(this.newSurveyTitle); // selected vision
        const currentSurvey = localStorage.getItem('current_survey');
        // Check login
        if (this.email != null && this.email !== 'null') {
            // do nothing
        } else {
            this.router.navigateByUrl('home/user');
        }
        if (currentSurvey && currentSurvey !== 'null') {
            this.current_survey = JSON.parse(currentSurvey);
            visionService.getVisionData(this.current_survey.id).subscribe(result => {
                this.survey_data = result.Survey;
                this.current_criterias = this.survey_data.criterias;
                this.getCriteriasTitles();
            });
        }
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            if (params['id']) {
                this.criteriaId = params['id'];
                this.isEditMode = true;
            }
        });
        // edit mode and change values
        if (this.isEditMode) {
            this.assignEditValues();
        }
        // Add new vision if parameter visiontype sent  then add new vision
        if (this.isCreateNewSurvey) {
            this.newSurveyTitle = this.surveyTypes.getTitle(this.surveyTypeId);
            // change current vision
            this.changeCurrentSurvey(this.surveyTypeId);
        }

        this.criteriaTitle = new FormControl('criteriaTitle', Validators.required);
        this.criteriaCondition = new FormControl('');
        this.criteriaForm = new FormGroup({
            criteriaTitle: this.criteriaTitle,
            criteriaCondition: this.criteriaCondition
        });

    }
    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'container_bg');
    }

    addTitle(post) {
        this.title = post;
    }
    addTitle2(post) {
        this.title = post;
        document.getElementById('closeModalButton').click();
    }

    addImportance(val) {
        if (this.criteriaTitle.valid) {
            this.importance = val;
        } else {
        }
    }
    toggleConditions(val) {
        this.isConditions = true;
    }
    addCondition(formTitle, radioValue, formNumber) {
        if (this.conditionItems.length > 0) {
            this.disableButton = false;
        }

        if (this.formIsValid(formTitle, radioValue)) {
            this.tempForms[formNumber].valid = true;
            const criteriaOption: CriteriaOptionDetails = { title: formTitle, importance: radioValue, addIndex: formNumber };
            this.deleteRepeatedTitleFromArray(formNumber);
            this.conditionItems.push(criteriaOption);
        } else {
            this.tempForms[formNumber].valid = false;
        }
    }
    formIsValid(textValue: string, radioValue: any) {
        if ((textValue !== '') && (radioValue && radioValue !== '')) {
            return true;
        } else {
            return false;
        }
    }
    openAddConditionsModal(content) {
        this.modalService.open(content, { windowClass: 'modal-conditions' });
    }
    titleChange(refValue) {
        if (!refValue || refValue === '') {
            this.disableButton = true;
        } else {
            this.disableButton = false;
        }
    }
    addAnotherForm(optId) {
        // add another conditions form
        if (this.conditionItems.length > 0) {
            this.disableButton = false;
        }
        const index = this.tempForms.length;
        this.tempForms.push({ form: 'form' + index, status: 'display', valid: false, addIndex: index, optionId: optId });
        this.displayArray.push({ index: index, display: 1 });
    }

    onFormChange(formOutput: Array<any>) {
        let formTitle: any;
        let radioValue: any;
        let formNumber: any;
        formOutput.forEach(element => {
            if (formOutput[0].formTitle) { formTitle = formOutput[0].formTitle; }
            if (formOutput[0].radioValue) { radioValue = formOutput[0].radioValue; }
            if (formOutput[0].formNumber) { formNumber = formOutput[0].formNumber; }
        });
        if (!formNumber || formNumber === undefined) {
            formNumber = 0;
        }
        if (formTitle && radioValue) {
            this.addCondition(formTitle, radioValue, formNumber);
        }
    }
    closePopupModal() {
        document.getElementById('closeModalButton').click();
    }
    open(content) {
        this.modalService.open(content).result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }
    openEditExamplesModal(content) {
        this.modalService.open(content, { windowClass: 'critEdit-examples' }).result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }
    openEmptyModal(content) {
        this.modalService.open(content, { windowClass: 'crtAdd-emptyMod' }).result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }
    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    registerCriteriaEdit() {
        if (this.conditionItems.length < 1) {
            this.disableButton = true;
            return true;
        }
        this.spinnerService.show();
        this.disableButton = true;
        const currentSurvey = localStorage.getItem('current_survey');
        if (!currentSurvey || currentSurvey === 'null') {
            // If no vision then add new vision
            this.newSurveyTitle = this.surveyTypes.getTitle(this.surveyTypeId);
            this.createNewVision().subscribe(result => {
                // delay and create criteria
                setTimeout(() => {
                    this.editTheCriteria();
                }, 0);
            });
        } else {
            this.editTheCriteria();
        }
    }

    editTheCriteria() {
        this.criteriaData = { id: this.criteriaId, title: this.title, importance: this.importance, options: this.conditionItems };
        const surveyData = localStorage.getItem('current_survey');
        if (surveyData) { this.surveyData = JSON.parse(surveyData); }
        // delete options first
        const optionsIds: Array<string> = [];
        const answerIds: Array<string> = [];
        let allMutations = `mutation {`;
        // ======= Deleting options and answers
        let optionsIndex = 0;
        const deletedOptions = this.tempForms.filter(x => x.status === 'deleted');
        if (deletedOptions.length > 0) {
            deletedOptions.forEach(option => {
                optionsIndex++;
                let answerIndex = 0;
                if (option.optionId && option.optionId !== 'undefined') {
                    optionsIds.push(option.optionId);
                    const optionAnswers = this.allAnswers.filter(x => x.optionId === option.optionId);
                    optionAnswers.forEach(answer => {
                        answerIndex++;
                        if (answer.answerId !== undefined) {
                            answerIds.push(answer.answerId);
                        }
                    });
                    allMutations += this.criteriaService.buildDeleteAnswers2(answerIds);
                    allMutations += this.criteriaService.buildDeleteOptions2(optionsIds);
                }
            });
        }
        // ======= End delete
        // ======= Edit old and Add new Options
        let editOptionIndex = 0;
        this.tempForms.forEach(item => {
            editOptionIndex++;
            if (item.optionId && item.optionId !== 'undefined' && item.status !== 'deleted') {
                const optionItem = this.editValuesArray.filter(x => x.id === item.optionId)[0];
                if (optionItem && optionItem.title !== '') {
                    allMutations += this.criteriaService.buildEditOption(optionItem.id, optionItem.title, optionItem.importance);
                }
            }
            // add new options
            if (item.optionId === undefined && item.status !== 'deleted') {
                const optionItemAdd = this.conditionItems.filter(x => x.addIndex === item.addIndex)[0];
                if (optionItemAdd && optionItemAdd.title !== '') {
                    allMutations += this.criteriaService.buildAddOption(item.addIndex, this.currentCriteria.id, optionItemAdd.title, optionItemAdd.importance);
                }
            }
        });
        allMutations += ' }';
        this.criteriaService.mutateEditCriteria(allMutations).subscribe(data => {
            this.criteriaService.editCriteria(this.currentCriteria.id, this.title, this.importance).subscribe(resp => {
                this.spinnerService.hide();
                this.disableButton = false;
                this.router.navigateByUrl('vision/editcriterias'); // redirect after adding options
            });
        });

        // ======= End add and edit options

    }

    cancelCriteria() {
        this.router.navigateByUrl('vision/editcriterias'); // redirect after adding options
    }
    getCriteriasTitles() {
        let i = 0;
        if (this.current_criterias) {
            this.current_criterias.forEach(criteria => {
                this.criterias_titles += criteria.title;
                if (i < this.current_criterias.length - 1) { this.criterias_titles += ','; }
                i++;
            });
        }
    }

    createNewVision() {
        return this.visionService.getUserVisions(this.email).map(result => {
            this.user_data = result.User;
            if (this.user_data.surveys) {
                const isExist = this.user_data.surveys.filter(
                    x => x.title === this.newSurveyTitle
                )[0];
                if (isExist) {
                    this.visionService.getVisionData(isExist.id).subscribe(data => {
                        this.survey_data = data.Survey;
                        localStorage.setItem('current_survey', JSON.stringify(data.Survey)
                        );
                        return false;
                    });
                } else {
                    this.addNewVision().subscribe(data => {
                        return result; // true or false created
                    });
                }
            }
        });
    }

    addNewVision() {
        this.spinnerService.show();
        this.disableButton = true;

        return this.visionService.addNewVision(this.newSurveyTitle, this.email, this.user_id, this.visionService.getTypeJobsId())
            .map(({ data }: any) => {
                localStorage.setItem('current_survey', JSON.stringify(data.createSurvey));
                localStorage.setItem('vision_title', this.newSurveyTitle);
                this.visionModel.setSurveysInStorage(data.createSurvey);
                this.spinnerService.hide();
                this.disableButton = false;
                return true;
            },
            error => {
                return false;
            }
            );
    }

    changeCurrentSurvey(visionType) {
        // check if vision available to add
        this.visionModel.visionIsExist(visionType).subscribe(result => {
            // change current vision localstorage values
            if (result === true) {
                localStorage.setItem('current_survey', null);
                localStorage.setItem('vision_title', this.newSurveyTitle);
                this.surveyTypeId = this.surveyTypes.getTitleId(this.newSurveyTitle); // selected vision
            } else {
                localStorage.setItem('current_survey', null);
                localStorage.setItem('vision_title', this.newSurveyTitle);
                this.surveyTypeId = this.surveyTypes.getTitleId(this.newSurveyTitle); // selected vision
            }
        });
    }

    assignEditValues() {
        this.criteriaService.getCriteriaData(this.criteriaId).subscribe(data => {
            this.currentCriteria = data.Criteria;

            // check if same criterias of the user logged in
            let isOwner = false;
            this.visionService.getUserVisionsCriterias(this.email).subscribe(({ User }: any) => {
                this.userSurveys = User.surveys;
                this.userSurveys.forEach(survey => {
                    const isExistInUserOffers = survey.criterias.filter(x => x.id === this.criteriaId)[0];
                    if (isOwner === false && isExistInUserOffers != null) {
                        if (isOwner === false) {
                            isOwner = true;
                        }
                    }
                });
                if (isOwner === false) {
                    this.router.navigateByUrl('home/user');
                }
                if (isOwner === true) {
                    this.title = this.currentCriteria.title;
                    this.importance = this.currentCriteria.importance;
                    this.isConditions = true;
                    let optionIndex = 0;
                    this.currentCriteria.options.forEach(option => {
                        this.conditionItems.push({
                            id: option.id, title: option.title
                            , importance: option.importance, addIndex: optionIndex
                        });
                        this.editValuesArray.push({
                            id: option.id, title: option.title
                            , importance: option.importance, addIndex: optionIndex
                        });
                        this.addAnotherForm(option.id);
                        optionIndex++;
                    });
                    this.conditionItems.forEach(item => {
                        item.id = 'test';
                    });
                    // get all answers
                    this.currentCriteria.options.forEach(option => {
                        this.jobService.getOptionAnswers(option.id).subscribe(resp => {
                            resp.allAnswers.forEach(answer => {
                                this.allAnswers.push({ optionId: option.id, answerId: answer.id });
                            });
                        });
                    });
                }
            });
        });
    }

    clearTitle(formTitleNumber) {
        if (formTitleNumber === 1) {
            this.title = '';
        }
    }

    emptyTitleFromArray(formNumber: number) {
        const selectedItem = this.conditionItems.filter(x => x.addIndex === formNumber)[0];
        if (selectedItem) {
            const index: number = this.conditionItems.indexOf(selectedItem);
            if (index !== -1) {
                this.conditionItems[index].title = '';
            }
        }
    }

    deleteRepeatedTitleFromArray(formNumber: number) {
        const selectedItem = this.conditionItems.filter(x => x.addIndex === formNumber)[0];
        if (selectedItem) {
            const index: number = this.conditionItems.indexOf(selectedItem);
            if (index !== -1) {
                this.conditionItems.splice(index, 1);
            }
        }
    }

    onElementDeleted(elementIndex: any) {
        if (elementIndex !== -1) {
            this.tempForms[elementIndex].status = 'deleted';
            this.displayArray[elementIndex].display = 0;
            this.emptyTitleFromArray(elementIndex);
            this.reCheckAllFormsValidity();
        }
    }

    onFormError(refValue) {
        if (refValue === 1) {
            this.disableButton = true;
        } else if (refValue === 0) {
            this.disableButton = false;
        }
    }

    reCheckAllFormsValidity() {
        let isValid = true;
        this.tempForms.forEach(form => {
            if (form.status === 'display' && form.valid === false) {
                isValid = false;
                return isValid;
            }
        });
        if (isValid) {
            this.allValid = 1;
        }
        return isValid; // default return isValid true
    }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/criteria/criteria.edit.component.ts